import React from 'react';

const AnalyticsPageContext = React.createContext({
  analyticsPageName: undefined,
  userData: {},
  locale: 'en',
});

const withAnalyticsPageName = (WrappedComponent) => {
  const WithAnalyticsPageName = (props) => (
    <AnalyticsPageContext.Consumer>
      {({ analyticsPageName, userData, locale }) => (
        <WrappedComponent
          {...props}
          analyticsPageName={analyticsPageName}
          userData={userData}
          locale={locale}
        />
      )}
    </AnalyticsPageContext.Consumer>
  );

  const wrappedComponentName = WrappedComponent.displayName
    || WrappedComponent.name
    || 'Component';
  WithAnalyticsPageName.displayName = `WithAnalyticsPageName(${wrappedComponentName})`;

  return WithAnalyticsPageName;
};

export {
  AnalyticsPageContext,
  withAnalyticsPageName,
};
